import { Component, forwardRef, Input } from '@angular/core';
import { BT_LABEL_TEXT_STYLE, BtLabelModel } from '../bt-label.model';

@Component({
    selector: 'bt-label-design',
    templateUrl: './bt-label-design.component.html',
    styleUrls: ['./bt-label-design.component.scss']
})
export class BtLabelDesignComponent {
    @Input() model: BtLabelModel;
    @Input() value: any;
    BT_LABEL_TEXT_STYLE = BT_LABEL_TEXT_STYLE;
}